export default "\r\n<app-state-list></app-state-list>\r\n\r\n\r\n";